import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Consorcio } from '../../model/consorcio';
import { Sucursal } from '../../model/sucursal';

import { ServiciosEspeciales } from '../../model/servicios-especiales';
import { CatalogoServicios } from '../../model/catalogo-servicios';
import { MonedaService } from '../../services/moneda.service';
import { ServicioEspecialService } from '../../services/servicio-especial.service';


import { CatalogoServiciosService } from '../../services/catalogo-servicios.service';
import { Moneda } from '../../model/moneda';

@Component({
  selector: 'app-servicio-especial-mantenimiento',
  templateUrl: './servicio-especial-mantenimiento.component.html',
  styleUrls: ['./servicio-especial-mantenimiento.component.css']
})
export class ServicioEspecialMantenimientoComponent implements OnInit {

  @Input() documentoSeleccionado: ServiciosEspeciales;
  @Input() consorcio: Consorcio;
  @Input() codigoSucursal: string;
  @Output() onReturn = new EventEmitter();

  public monedas: Moneda[];

  public servicios: CatalogoServicios[];
  public servicioCobro: ServiciosEspeciales = new ServiciosEspeciales();

  public estadoBorrar: boolean = false;
  public estadoEditar: boolean = false;

  public query: any;

  constructor(
    private _servicios: CatalogoServiciosService,
    private _monedaService: MonedaService,
    private _cobro: ServicioEspecialService
  ) { }

  ngOnInit() {
    if (sessionStorage.getItem("login") === null) {
      window.location.href = "/";
    }
    this._monedaService.getMonedas()
      .subscribe(
      monedas => this.monedas = monedas,
      err => {
        console.log(err);
      });

    if (this.documentoSeleccionado.id != undefined) {
      this.estadoEditar = true;
      this.servicioCobro = this.documentoSeleccionado;
    }
    this.cargarServicios();
  }


  cargarServicios() {
    this.query = { "codigoConsorcio": this.consorcio.codigoConsorcio };
    this._servicios.getServicios(this.query)
      .subscribe(
      data => this.servicios = data,
      err => {
        console.log(err._body);
      });
  }

  onSubmit() {
    if (this.servicioCobro.id === undefined) {
      this.servicioCobro.id = 0;
    }
    if (this.servicioCobro.id === 0) {
      this.servicioCobro.estado = "PENDIENTE";
    }

    if (this.servicioCobro.codigoDocumento === undefined )
    {
        this.servicioCobro.codigoDocumento = "";
    }

    if (this.servicioCobro.tipoDocumento ===  undefined)
    {
        this.servicioCobro.tipoDocumento = "";
    }


    this.servicioCobro.codigoConsorcio = this.consorcio.codigoConsorcio;
    this.servicioCobro.codigoSucursal = this.codigoSucursal;
    this._cobro.insert(this.servicioCobro).subscribe(
      result => this.onSubmitSuccess(result),
      err => {
        console.log(err._body);
      });
  }

   asignarCostoEstandar(codigoServicio: string){
    for(let i = 0; i < this.servicios.length; i++){
      if(this.servicios[i].codigoServicio === codigoServicio){
        this.servicioCobro.montoServicio = this.servicios[i].costoEstandar;
        break;
      }
    }      
  }

  calcularTotal(){
    this.servicioCobro.total = (this.servicioCobro.cantidad * this.servicioCobro.montoServicio);
  }


  onSubmitSuccess(data: any) {
    this.regresar();
  }

  /* Navegación */
  regresar() {
    this.onReturn.emit();
  }

  solicitaBorrar() {
    this.estadoBorrar = true;
  }

  solicitudBorrarCancelar() {
    this.estadoBorrar = false;
  }

  borrarRegistro(){
    this._cobro.delete(this.servicioCobro).subscribe(
      result => {
        this.regresar();
      },
      err => {
        console.log(err._body);
      });
  }

}



// WEBPACK FOOTER //
// D:/Proyectos/tpl viejo prueba/eflowTPL/src/app/components/servicio-especial-mantenimiento/servicio-especial-mantenimiento.component.ts